import { render, staticRenderFns } from "./NativeBar.vue?vue&type=template&id=157ce5b4&scoped=true&"
import script from "./NativeBar.vue?vue&type=script&lang=js&"
export * from "./NativeBar.vue?vue&type=script&lang=js&"
import style0 from "./NativeBar.vue?vue&type=style&index=0&id=157ce5b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157ce5b4",
  null
  
)

export default component.exports